module.exports = __webpack_public_path__ + "static/img/zjpl.5dea945.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homeContent/zjpl.png
// module id = JXuC
// module chunks = 1